import { render, staticRenderFns } from "./FamilyModal.vue?vue&type=template&id=66973bd7&"
import script from "./FamilyModal.vue?vue&type=script&lang=js&"
export * from "./FamilyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports